// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick-theme.css";
// import "slick-carousel/slick/slick.css";

// const MySlider = (props) => {
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const handleResize = () => setIsMobile(window.innerWidth <= 768);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const desktopImages = [
//     { url: "https://aujdasturxpqlzqjbztf.supabase.co/storage/v1/object/public/animalia/slider/sliders.png", link: "/shop-details/1068" },
//     { url: "https://aujdasturxpqlzqjbztf.supabase.co/storage/v1/object/public/animalia/slider/sliiider.png", link: "/shop-details/951" },
//   ];

//   const mobileImages = [
//     { url: "https://aujdasturxpqlzqjbztf.supabase.co/storage/v1/object/public/animalia/slider/slm.png", link: "/shop-details/951" },
//     { url: "https://aujdasturxpqlzqjbztf.supabase.co/storage/v1/object/public/animalia/slider/slm1.png", link: "/shop-details/1068" },
//   ];

//   const images = isMobile ? mobileImages : desktopImages;
// const settings = {
//   dots: true,
//   infinite: true,
//   speed: 500,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   adaptiveHeight: true,
//   autoplay: isMobile,
//   autoplaySpeed: 3000,
//   arrows: true, // force arrows to show
//     centerMode: false,      // important
//   variableWidth: false,   // important
//   appendDots: (dots) => (
//     <div style={{ position: "absolute", bottom: 30, right: 10 }}>
//       <ul style={{ margin: 0 }}>{dots}</ul>
//     </div>
//   ),
//   nextArrow: <SampleNextArrow />,
//   prevArrow: <SamplePrevArrow />,
// };

// function SampleNextArrow(props) {
//   const { className, style, onClick } = props;
//   return (
//     <div
//       className={className}
//       style={{ ...style, display: "block", background: "rgba(0,0,0,0.5)", borderRadius: "50%" }}
//       onClick={onClick}
//     />
//   );
// }

// function SamplePrevArrow(props) {
//   const { className, style, onClick } = props;
//   return (
//     <div
//       className={className}
//       style={{ ...style, display: "block", background: "rgba(0,0,0,0.5)", borderRadius: "50%" }}
//       onClick={onClick}
//     />
//   );
// }

//   return (
//     <Slider {...settings}>
//       {images.map((slide) => (
//         <div key={slide.url}>
//           <img
//             onClick={() => navigate(slide.link)}
//             src={slide.url}
//             alt="Slide"
//             style={{
//               width: isMobile?"120%" :"100%",
//               height: "60vh",
//               minHeight: "220px",
//               objectFit: "cover",
//               cursor: "pointer",
//               marginLeft: isMobile ? "100px" : "0", 
//             }}
//           />
//         </div>
//       ))}
//     </Slider>
//   );
// };

// export default MySlider;
// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import { supabase } from "../lib/supabaseClient.ts";

// const getImageUrl = (path) => {
//   if (!path) return "";
//   const { data } = supabase.storage.from("animalia").getPublicUrl(path);
//   return data?.publicUrl || "";
// };

// const MySlider = ({ slides = [] }) => {
//   const navigate = useNavigate();
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

//   useEffect(() => {
//     const handleResize = () => setIsMobile(window.innerWidth <= 768);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   // Filter only active slides
//   const activeSlides = slides.filter(slide => slide.is_active);

//   const settings = {
//     dots: true,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 1,
//     slidesToScroll: 1,

//     autoplay: isMobile,
//     autoplaySpeed: 3000,

//     arrows: !isMobile, // Hide arrows on mobile
    
//     // ✅ IMPORTANT FIXES
//     centerMode: false,
//     variableWidth: false,
//     adaptiveHeight: false,

//     responsive: [
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           centerMode: false,
//           variableWidth: false,
//           arrows: false,
//         },
//       },
//     ],

//     appendDots: (dots) => (
//       <div style={{ position: "absolute", bottom: 20, right: 10, zIndex: 10 }}>
//         <ul style={{ margin: 0, listStyle: "none" }}>{dots}</ul>
//       </div>
//     ),
//   };

//   return (
//     <div style={{ overflow: "hidden", width: "100%" }}>
//       <Slider {...settings}>
//         {activeSlides.map((slide) => {
//           // Select appropriate image based on device
//           const imageUrl = isMobile 
//             ? getImageUrl(slide.image_mobile) 
//             : getImageUrl(slide.image_desktop);

//           return (
//             <div key={slide.id}>
//               <img
//                 src={imageUrl}
//                 alt={slide.title || "Slide"}
//                 onClick={() => slide.link && navigate(slide.link)}
//                 style={{
//                   width: "100%",
//                   height: isMobile ? "auto" : "60vh",
//                   maxHeight: isMobile ? "80vh" : "60vh",
//                   objectFit: "cover",
//                   display: "block",
//                   cursor: slide.link ? "pointer" : "default",
//                 }}
//               />
//             </div>
//           );
//         })}
//       </Slider>
//     </div>
//   );
// };

// export default MySlider;

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { supabase } from "../lib/supabaseClient.ts";

const getImageUrl = (path) => {
  if (!path) return "";
  const { data } = supabase.storage.from("animalia").getPublicUrl(path);
  return data?.publicUrl || "";
};

const MySlider = ({ slides = [] }) => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Filter only active slides
  const activeSlides = slides.filter(slide => slide.is_active);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: isMobile,
    autoplaySpeed: 3000,
    arrows: !isMobile,

    // ✅ CRITICAL FIXES - force single full slide
    centerMode: false,
    variableWidth: false,
    adaptiveHeight: false,

    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          variableWidth: false,
          arrows: false,
          // ✅ Add these to prevent partial slides
          swipeToSlide: false,
          touchThreshold: 5,
        },
      },
    ],

    appendDots: (dots) => (
      <div style={{ position: "absolute", bottom: 20, right: 10, zIndex: 10 }}>
        <ul style={{ margin: 0, listStyle: "none" }}>{dots}</ul>
      </div>
    ),
  };

  return (
    <div style={{ overflow: "hidden", width: "100%" }}>
      <Slider {...settings}>
        {activeSlides.map((slide) => {
          const imageUrl = isMobile 
            ? getImageUrl(slide.image_mobile) 
            : getImageUrl(slide.image_desktop);

          return (
            // ✅ KEY FIX: Force each slide to be exactly 100% width
            <div 
              key={slide.id} 
              style={{ 
                width: "100% !important", 
                maxWidth: "100%",
                position: "relative",
              }}
            >
              <img
                src={imageUrl}
                alt={slide.title || "Slide"}
                onClick={() => slide.link && navigate(slide.link)}
                style={{
                  width: "100%",
                  height: isMobile ? "auto" : "60vh",
                  marginLeft: isMobile ? "100px" : "0",
                  maxHeight: isMobile ? "80vh" : "60vh",
                  objectFit: "cover",
                  display: "block",
                  cursor: slide.link ? "pointer" : "default",
                }}
              />
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default MySlider;